
/* injects from baggage-loader */

export const failDialg = [`Parece que você se <b>confundiu</b>! <br> <b>Observe</b> novamente e <b>reescreva</b> os numerais apenas nos <b>quadrinhos destacados</b> com a cor vermelha.`]

export const feedbackFinishStage = [
  'Graças aos seus <b>esforços</b> nesta <br> missão, você ganhou a Medalha Oficial de <b>AJUDANTE DOS ANIMAIS</b>!',
  'Você também será recompensado com <b>1/4 do distintivo</b> de <b>Guardião da Natureza</b>. para completá-lo, você precisa <b>concluir</b> também só mais <b>uma</b> missão. Preparado?',
]

export const successDialg = [
  'Você <b>conseguiu</b>!<br>Vamos para o<br><b>próximo</b> desafio?'
]


// WEBPACK FOOTER //
// ./src/app/components/dialogs/quiz-macaco/quiz-macaco.const.js